module.exports = "/static/assets/3bfb87273369a7962be885d2536a739c.gif";